<template>
  <el-card  id="confManageTemp">
    <!--条件查询-->
    <div class="search-form">
      <el-form inline :model="originData" ref="searchForm">
        <el-form-item label="更新时间" prop="updateTimeStart">
          <el-date-picker type="date" v-model="originData.updateTimeStart" placeholder="起始日期" class="search-ipt upt-start"/>
          <span style="margin:auto 10px;color:#999999">至</span>
          <el-date-picker type="date" v-model="originData.updateTimeEnd" placeholder="结束日期" class="search-ipt upt-end"/>
        </el-form-item>
        <el-form-item label="提示字段名称" prop="tipsName">
          <el-input placeholder="请输入提示字段名称" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.tipsName"/>
        </el-form-item>
        <el-form-item label="提示字段标识" prop="tipsIdentif">
          <el-input placeholder="请输入提示字段标识" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.tipsIdentif"/>
        </el-form-item>
        <el-form-item label="状态" prop="tipsStatus">
          <el-select v-model.trim="originData.tipsStatus">
            <el-option
              v-for="item in tipsStatusEnum"
              :key="item.value"
              :label="item.label"
              :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="归属模块" prop="moduleType">
          <el-select v-model.trim="originData.moduleType">
            <el-option
              v-for="item in moduleData"
              :key="item.moduleIdentif"
              :label="item.moduleName"
              :value="item.moduleIdentif"/>
            <el-option label="全部" value="" />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="search"
        >查询</el-button>
        <el-button
          size="small"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click='addDialogCtrl()'
           v-if="judgeJurisdiction('412820067270479872')"
        >新增提示</yh-button>
      </div>
    </div>
    <!--提示信息列表-->
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%">
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column label="提示字段ID" prop="id" align="center"/>
        <el-table-column label="提示字段标识" prop="tipsIdentif" align="center"/>
        <el-table-column label="提示字段名称" prop="tipsName" align="center"/>
        <el-table-column label="提示内容" prop="tipsComment" align="center"/>
        <el-table-column label="归属模块" prop="moduleName" align="center"/>
        <el-table-column
          prop="tipsStatus"
          label="状态"
          width="200"
          align="center">
          <template slot-scope="scope">{{scope.row.tipsStatus  | tipStatusFilter}}</template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updateTime" align="center"/>
        <el-table-column label="更新人ID" prop="updateUser" align="center"/>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span
              class="button--blue"
              @click="editDialogCtrl(scope.row)"
              type="primary"
              v-if="judgeJurisdiction('412820219771179008')"
            >修改</span>
            <span
              class="button--blue"
              @click="editTipStatusOpen(scope.row)"
              v-if="scope.row.tipsStatus === disableStatus&&judgeJurisdiction('412820368098545664')"
            >启用</span>
            <span
              class="button--red"
              @click="editTipStatusClose(scope.row)"
              v-if="scope.row.tipsStatus !== disableStatus&&judgeJurisdiction('412820368098545664')"
            >禁用</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!--分页-->
    <el-row style="text-align:center">
      <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
      />
    </el-row>
    <!--新增提示信息模态框-->
    <yh-dialog title="新增提示配置" :visible.sync="addDialogVisible">
      <el-form :model="addTipData" class="hide-error" label-width="110px">
        <el-form-item label="提示字段名称" prop="tipsName" required>
          <el-input v-model="addTipData.tipsName" placeholder="请输入提示信息名称，不超过20字" maxlength="20"/>
        </el-form-item>
        <el-form-item label="提示字段标识" prop="tipsIdentif" required>
          <el-input v-model="addTipData.tipsIdentif" placeholder="请输入提示信息标识，不超过40字" maxlength="40"/>
        </el-form-item>
        <el-form-item label="归属模块" prop="moduleType" required>
          <el-select  v-model="addTipData.moduleType" placeholder="请选择归属模块" style="width:100%">
            <el-option
              v-for="item in moduleData"
              :key="item.moduleIdentif"
              :label="item.moduleName"
              :value="item.moduleIdentif"/>
          </el-select>
        </el-form-item>
        <el-form-item label="提示内容" prop="tipsComment" required>
          <el-input type="textarea" v-model="addTipData.tipsComment"  :autosize="{ minRows: 5}" placeholder="请输入提示信息说明，不超过500字" maxlength="500"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoadFlag" @click="addTipDetail();">提交</el-button>
      </span>
    </yh-dialog>
    <!--修改提示信息模态框-->
    <yh-dialog title="修改提示配置" :visible.sync="editDialogVisible">
      <el-form :model="editTipData" class="hide-error" label-width="110px">
        <el-form-item label="提示字段名称" prop="tipsName" required>
          <el-input v-model="editTipData.tipsName" placeholder="请输入提示信息名称，不超过20字" maxlength="20"/>
        </el-form-item>
        <el-form-item label="提示字段标识" prop="tipsIdentif" required>
          <el-input v-model="editTipData.tipsIdentif" disabled/>
        </el-form-item>
        <el-form-item label="归属模块" prop="moduleType" required>
          <el-select  v-model="editTipData.moduleType" placeholder="请选择归属模块" style="width:100%">
            <el-option
              v-for="item in moduleData"
              :key="item.moduleIdentif"
              :label="item.moduleName"
              :value="item.moduleIdentif"/>
          </el-select>
        </el-form-item>
        <el-form-item label="提示内容" prop="tipsComment" required>
          <el-input type="textarea" v-model="editTipData.tipsComment"  :autosize="{ minRows: 5}" placeholder="请输入提示信息说明，不超过500字" maxlength="500"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoadFlag" @click="editParamDetail();">确定</el-button>
      </span>
    </yh-dialog>
  </el-card>
</template>
<script>
import { getFunctionList, getPagingData } from '@/mixins';

export default {
  mixins: [getFunctionList, getPagingData],
  data() {
    return {
      functionList: [],
      emptyText: this.$LS.empty,
      errorCode: 'E00000',
      // 条件查询
      originData: {
        updateTimeStart: '',
        updateTimeEnd: '',
        tipsName: '',
        tipsIdentif: '',
        tipsStatus: '',
        moduleType: '',
      },
      searchParam: {
        updateTimeStart: '',
        updateTimeEnd: '',
        tipsName: '',
        tipsIdentif: '',
        tipsStatus: '',
        moduleType: '',
      },
      // 新增数据集
      addTipData: {
        tipsIdentif: '',
        tipsName: '',
        tipsComment: '',
        moduleType: 'commonModule',
      },
      // 修改数据集
      editTipData: {
        id: '',
        tipsIdentif: '',
        tipsName: '',
        tipsComment: '',
        moduleType: '',
      },
      // 提示信息列表
      tableData: [],
      // 状态
      tipsStatusEnum: [
        {
          value: '1',
          label: '禁用',
        }, {
          value: '2',
          label: '启用',
        }, {
          value: '',
          label: '全部',
        },
      ],
      // 当前页码
      currentPage: 1,
      pageSize: 10,
      pageNo: 1,
      // 数据量
      sumCount: 0,
      // 新增模态框可见标记
      addDialogVisible: false,
      // 修改模态框可见标记
      editDialogVisible: false,
      addLoadFlag: false,
      editLoadFlag: false,
      // 禁用状态
      disableStatus: '1',
      // 模块列表
      moduleData: [],
    };
  },
  watch: {
    // 分页查询
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData(true);
        this.getModuleList();
      },
    },
  },
  mounted() {
    const token = this.$route.query.userToken;
    const sessionData = JSON.parse(this.$route.query.sessionData);
    sessionStorage.setItem('userToken', JSON.stringify(token));
    sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
    this.getJurisdiction();
  },
  methods: {
    // 获取功能权限
    getJurisdiction() {
      const params = {
        data: {
          roleId: JSON.parse(sessionStorage.getItem('sessionData')).roleId,
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          token: JSON.parse(sessionStorage.getItem('userToken')),
        },
      };
      this.$_post(this.$API.get_role_menu, params).then((res) => {
        console.log(res);
        this.functionList = res.data.roleMenuList;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 判断是否有权限
    judgeJurisdiction(v) {
      for (let index = 0; index < this.functionList.length; index++) {
        if (this.functionList[index].menuId === v) {
          return true;
        }
      }
      return false;
    },
    // 重置条件查询
    reset() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    search() {
      this.searchParam = { ...this.originData };
      this.currentPage = 1;
      this.pageNo = 1;
      this.getTableData();
    },
    // 提示信息查询
    getTableData(emptyValue) {
      this.getPagingData(this.$API.getTipList, emptyValue);
    },
    // 模块查询
    getModuleList() {
      const params = {};
      this.$_post(this.$API.getModuleList, params).then((res) => {
        this.moduleData = res.data.list;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 新增提示信息
    addTipDetail() {
      // 非空判断
      if (this.addTipData.tipsName === '') {
        this.$message({
          message: '请输入提示字段名称',
          type: 'warning',
          showClose: true,
        });
        return;
      }
      if (this.addTipData.tipsIdentif === '') {
        this.$message({
          message: '请输入提示字段标识',
          type: 'warning',
          showClose: true,
        });
        return;
      }
      if (this.addTipData.moduleType === '') {
        this.$message({
          message: '请选择归属模块',
          type: 'warning',
          showClose: true,
        });
        return;
      }
      if (this.addTipData.tipsComment === '') {
        this.$message({
          message: '请输入提示内容',
          type: 'warning',
          showClose: true,
        });
        return;
      }
      this.addLoadFlag = true;
      this.$_yh_confirm('提示字段新增后将无法删除，确定要新增吗？', '新增提示').then(() => {
        const params = {
          data: {
            tipsName: this.addTipData.tipsName,
            tipsIdentif: this.addTipData.tipsIdentif,
            tipsComment: this.addTipData.tipsComment,
            moduleType: this.addTipData.moduleType,
            updateUser: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            createUser: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          },
        };
        this.$_post(this.$API.addTipDetail, params).then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
            this.addLoadFlag = false;
            this.addDialogVisible = false;
            this.getTableData();
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
            this.addLoadFlag = false;
          }
        }).catch((error) => {
          console.log(error);
          this.addLoadFlag = false;
        });
      }).catch(() => {
        this.addLoadFlag = false;
      });
    },
    // 编辑提示信息
    editParamDetail() {
      if (this.editTipData.tipsName === '') {
        this.$message({
          message: '请输入提示字段名称',
          type: 'warning',
          showClose: true,
        });
        return;
      }
      if (this.editTipData.moduleType === '') {
        this.$message({
          message: '请选择归属模块',
          type: 'warning',
          showClose: true,
        });
        return;
      }
      if (this.editTipData.tipsComment === '') {
        this.$message({
          message: '请输入提示内容',
          type: 'warning',
          showClose: true,
        });
        return;
      }
      this.editLoadFlag = true;
      this.$_yh_confirm(`确认要修改"${this.editTipData.tipsIdentif}"的提示信息吗？`).then(() => {
        const params = {
          data: {
            id: this.editTipData.id,
            tipsName: this.editTipData.tipsName,
            tipsIdentif: this.editTipData.tipsIdentif,
            tipsComment: this.editTipData.tipsComment,
            moduleType: this.editTipData.moduleType,
            updateUser: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            createUser: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          },
        };
        this.$_post(this.$API.editTipDetail, params).then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
            this.editDialogVisible = false;
            this.getTableData();
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
          this.editLoadFlag = false;
        }).catch((error) => {
          console.log(error);
          this.editLoadFlag = false;
        });
      }).catch(() => {
        this.editLoadFlag = false;
      });
    },
    // 启用
    editTipStatusOpen(row) {
      this.$_yh_confirm(`确定要启用"${row.tipsName}"的提示？`, '启用提示').then(() => {
        const params = {
          data: {
            id: row.id,
            tipsStatus: row.tipsStatus,
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          },
        };
        this.$_post(this.$API.editTipStatus, params).then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
            this.getTableData();
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
        }).catch((error) => {
          console.log(error);
        });
      }).catch(() => {});
    },
    // 禁用
    editTipStatusClose(row) {
      this.$_yh_confirm(`禁用后，对应的财富规划对应的名词提示将失效，确定要禁用"${row.tipsName}"的提示？`, '禁用提示').then(() => {
        const params = {
          data: {
            id: row.id,
            tipsStatus: row.tipsStatus,
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          },
        };
        this.$_post(this.$API.editTipStatus, params).then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
            this.getTableData();
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
        }).catch((error) => {
          console.log(error);
        });
      }).catch(() => {});
    },
    // 新增模态框控制器
    addDialogCtrl() {
      // 清理历史新增数据
      this.addTipData.tipsIdentif = '';
      this.addTipData.tipsName = '';
      this.addTipData.tipsComment = '';
      this.addTipData.moduleType = 'commonModule';
      // 打开新增模态框
      this.addDialogVisible = true;
    },
    // 编辑模态框控制器
    editDialogCtrl(row) {
      this.editTipData.tipsIdentif = row.tipsIdentif;
      this.editTipData.tipsName = row.tipsName;
      this.editTipData.tipsComment = row.tipsComment;
      this.editTipData.moduleType = row.moduleType;
      this.editTipData.id = row.id;
      // 打开编辑模态框
      this.editDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
#confManageTemp {
  overflow: initial;
  .search-col {
    display: flex;
  }
  .search-col-div {
    display: table;
    line-height: 27px;
  }
  .editKey {
    line-height: 40px;
    text-align: right;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
  }
}
</style>
